import { Box } from "@mui/material";
import React, { useState } from "react";
import PaymentDropItemComponent from "./PaymentDropItemComponent";
import PaymentList from "./PaymentListDataGrid";

const PaymentHistoryScreen = () => {
  const [paymentFilter, setPaymentFilter] = useState("All");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection:"column",
          gap:"30px"
        }}
      >
        <Box sx={{ width: "100%" }}>
          <PaymentDropItemComponent paymentFilter={paymentFilter} setPaymentFilter={setPaymentFilter} setEndDate={setEndDate}
            endDate={endDate}
            startDate={startDate}
            setStartDate={setStartDate} />
        </Box>
        <Box sx={{width:"100%"}}> 
          <PaymentList paymentFilter={paymentFilter} endDate={endDate}
            startDate={startDate} />
        </Box>
      </Box>
    </>
  )
}

export default PaymentHistoryScreen